module.exports = __webpack_public_path__ + "img/背景卡图.0bcaa894.png";